@if (isVisible) {
  <div class="row justify-flex-end page-selector">
    <input
      class="page-selector-input"
      appFilterInput
      [allowDot]="false"
      [allowComma]="false"
      (input)="onPageChange($event.target.value)"
      placeholder="{{ 'Shell.generic.goToPage' | translate }}"
      #pageSelectorInput
      />
    </div>
  }
